export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-08.ab43df1a.png";